export default "__VITE_ASSET__ChpFuqsX__"